<template>
    <h2>Študijné skupiny</h2>
    <v-card-text>
        <GroupsStudent v-if="user_type == 'student'" />
        <GroupsTeacher v-if="user_type == 'teacher'" />
    </v-card-text>
</template>

<script>
import axios from '../../axios-auth.js'
import GroupsStudent from '../../components/study_groups/gr_student.vue'
import GroupsTeacher from '../../components/study_groups/gr_teacher.vue'

export default {
        data() {
            return {
                button_selection: 0,
                user_type: ''
        }
    },
    components: {
        GroupsStudent,
        GroupsTeacher
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getUserType()
        },
        getUserType() {
            axios.get('/get-study-group-user-type', this.$store.getters.getAxiosConfig)
            .then(res => {
                this.user_type = res.data.result  
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
    }
}
</script>